import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const Repeat = ({ times, render, wrapper }) => {
  const Wrapper = wrapper;
  const items = [];
  for (let i = 0; i < times; i += 1) {
    items.push(render(i));
  }
  return <Wrapper>{items}</Wrapper>;
};
Repeat.propTypes = {
  times: PropTypes.number.isRequired,
  render: PropTypes.func.isRequired,
  wrapper: PropTypes.oneOfType([
    PropTypes.symbol,
    PropTypes.func,
  ]),
};
Repeat.defaultProps = {
  wrapper: Fragment,
};

export default Repeat;
